import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    appRoot: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        boxSizing: 'border-box',
        padding: 0,
        marginTop: theme.spacing(8),
        marginBottom: 'calc(64px + env(safe-area-inset-bottom, 0px))',
    },
    powerDisplayContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2), // Adjust the spacing as needed
    },
    powerTextField: {
        marginRight: theme.spacing(1),
    },
    bar: {
        borderRadius: 5,
        height: 20,
        marginTop: 0,
        marginBottom: 0,
        backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 500 : 600],
    },
    appContent: {
        width: '100%',
        display: 'inline-block',
        boxSizing: 'border-box',
    },
    bottomNav: {},
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    alignCenter: {
        alignItems: 'center',
    },
    // ----------------------------------------
    text: {
        fontSize: 14,
        paddingRight: 5,
    },
    margin: {
        marginTop: '8vh',
        marginBottom: '8vh',
        display: 'flex',
        justifyContent: 'space-evenly',
    },
    inputForm: {
        marginTop: '5vh',
    },
    box: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '4vh',
    },
    boxMedium: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '4vh',
    },
    boxLine: {
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        marginTop: '4vh',
    },
    // ----------------------------------------
    title: {
        display: 'flex',
        justifyContent: 'center',
        fontSize: 12,
        fontWeight: 'bold',
        marginTop: '2vh',
        fontFamily: "'Heebo', sans-serif",
    },
    titleFontSize15: {
        display: 'flex',
        justifyContent: 'center',
        fontSize: 15,
        fontWeight: 'bold',
        marginTop: '2vh',
        color: 'red',
    },
    title1: {
        display: 'flex',
        justifyContent: 'center',
        fontSize: 12,
        fontWeight: 'bold',
        marginTop: '1vh',
        fontFamily: "'Heebo', sans-serif",
    },
    titleMed: {
        display: 'flex',
        justifyContent: 'center',
        fontSize: 12,
        fontWeight: '600',
    },
    titleHuge: {
        display: 'flex',
        justifyContent: 'center',
        fontSize: 25,
        fontWeight: 'bold',
        marginTop: '2vh',
    },
    titleRow: {
        display: 'flex',
        justifyContent: 'space-evenly',
        marginTop: '10vh',
    },
    titleRowSmall: {
        display: 'flex',
        justifyContent: 'space-evenly',
    },
    titleRowButtons: {
        display: 'flex',
        justifyContent: 'space-evenly',
        marginTop: '1vh',
        flexGrow: 6,
    },
    bleckColor: {
        color: 'black',
    },
    // ----------------------------------------
    row: {
        display: 'flex',
        justifyContent: 'space-evenly',
        marginTop: '2vh',
    },
    rowSpaceAround: {
        display: 'flex',
        justifyContent: 'space-around',
        borderBottom: '1px solid black',
        margin: 'auto',
    },

    rowColumn: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-evenly',
        // height: "16vh",
    },
    rowSmall: {
        display: 'flex',
        justifyContent: 'space-evenly',
    },
    editTextRightAligned: {
        marginBottom: '3.5vh',
        paddingLeft: 80,
    },
    marginBottom10: {
        marginBottom: '10px',
    },
    paddingLeft_75: {
        paddingLeft: 70,
    },
    paddingLeft_40: {
        paddingLeft: 40,
    },
    checkboxRow: {
        display: 'flex',
        justifyContent: 'flex-start',
    },
    checkbox: {
        paddingLeft: 95,
    },
    editChargerCheckbox: {
        paddingLeft: 80,
    },
    marginRight_75: {
        marginRight: 75,
    },
    margin40: {
        display: 'flex',
        justifyContent: 'flex-start',
        marginLeft: 40,
    },
    marginRight40: {
        display: 'flex',
        //justifyContent: 'flex-end',
        marginRight: 40,
    },
    rowMedium: {
        display: 'flex',
        justifyContent: 'space-evenly',
        height: '12vh',
    },
    rowLarge: {
        display: 'flex',
        justifyContent: 'space-evenly',
        height: '10vh',
    },
    rowWrapper: {
        width: '88%',
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'center',
    },
    dateRow: {
        padding: 15,
        display: 'flex',
        justifyContent: 'space-between',
        // marginTop: '2vh',
        width: '100%',
        alignContent: 'center',
        alignItems: 'center',
    },
    // ----------------------------------------
    flexColumnWithMargin: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '4vh',
    },
    columnRight: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'self-start',
        margin: '19px 26px 0px 20px',
    },
    // ----------------------------------------
    buttonsRow: {
        display: 'flex',
        justifyContent: 'space-evenly',
        marginTop: '2vh',
    },
    buttonsContainer: {
        //maxHeight: '60vh',
        // overflow: 'auto',
        overflowY: 'scroll',
        marginTop: 'auto',
    },
    buttonsContainerGroups: {
        maxHeight: '65vh',
        overflow: 'auto',
    },
    button: {
        width: '280px !important',
        borderRadius: '25px !important',
        background: '#005496 !important',
        color: 'white !important',
        '&:hover': {
            background: '#005496 !important',
            color: 'white !important',
        },
    },
    buttonSecondary: {
        width: '280px !important',
        borderRadius: '25px !important',
        border: '2px solid #005496',
        color: '#005496',
        background: 'transparent !important',
        marginTop: '10px',
        '&:hover': {
            border: '2px solid #005496',
            color: '#005496',
            background: 'transparent !important',
        },
    },
    forgotLink: {
        textDecoration: 'none',
        marginTop: '30px',
        color: '#005496',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    // ----- Auth centered card layout -----
    authShell: {
        minHeight: '100vh',
        backgroundColor: '#f4f4f4',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '24px 0',
        boxSizing: 'border-box',
    },
    authPage: {
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        backgroundColor: theme.palette.background.default,
        paddingTop: theme.spacing(8),
        paddingBottom: 0,
        boxSizing: 'border-box',
        width: '100%',
    },
    authLogoWrap: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 48,
        marginBottom: 24,
        '@media (min-width: 600px)': {
            marginTop: 72,
        },
    },
    authLogo: {
        height: 56,
        width: 'auto',
        objectFit: 'contain',
    },
    authLogoLarge: {
        maxWidth: 240,
        width: 'auto',
        height: 56,
        objectFit: 'contain',
    },
    authNavRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        flexWrap: 'wrap',
        justifyContent: 'center',
    },
    authCard: {
        maxWidth: 360,
        width: '90vw',
        backgroundColor: '#fff',
        borderRadius: 16,
        boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        border: '1px solid rgba(0,0,0,0.06)',
        padding: 28,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
    },
    authFormColumnContainer: {
        maxWidth: 360,
        width: '90vw',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        gap: theme.spacing(1),
        boxSizing: 'border-box',
    },
    signupNavRowWrap: {
        width: '100%',
        marginBottom: theme.spacing(0.5),
    },
    loginLikePageTitleRoot: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
    },
    loginLikePageTitleTop: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(1.5),
    },
    loginLikePageTitleText: {
        fontSize: 20,
        fontWeight: 700,
        color: theme.palette.text.primary,
        textAlign: 'center',
        margin: 0,
    },
    loginLikePageTitleDividerWrap: {
        width: '100%',
        height: 1,
        position: 'relative',
    },
    authFormContent: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    authInputsColumn: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    authCardScroll: {
        overflowY: 'auto',
        flex: '1 1 auto',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
    },
    authCardHeader: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 8,
        marginBottom: 8,
    },
    authPageTitleRoot: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
    },
    authPageTitleTop: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(1.5),
    },
    authPageTitleTopStart: {
        justifyContent: 'flex-start',
    },
    authPageTitleIconWrap: {
        width: theme.spacing(3),
        height: theme.spacing(3),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.primary.main,
        '& svg': {
            width: '100%',
            height: '100%',
        },
        '& img': {
            width: '100%',
            height: '100%',
            objectFit: 'contain',
        },
    },
    authPageTitleText: {
        fontSize: 20,
        fontWeight: 700,
        color: theme.palette.text.primary,
        textAlign: 'center',
        margin: 0,
    },
    authPageTitleTextStart: {
        textAlign: 'start',
    },
    authPageTitleDivider: {
        width: '100%',
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    authPageTitleDividerWrap: {
        width: '100%',
        height: 1,
        position: 'relative',
    },
    appPageTitleRoot: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
    },
    appPageTitleTop: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(1.5),
    },
    appPageTitleTopStart: {
        justifyContent: 'flex-start',
    },
    appPageTitleIconWrap: {
        width: theme.spacing(3),
        height: theme.spacing(3),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.primary.main,
        '& svg': {
            width: '100%',
            height: '100%',
        },
        '& img': {
            width: '100%',
            height: '100%',
            objectFit: 'contain',
        },
    },
    appPageTitleText: {
        fontSize: 'clamp(14px, 4.2vw, 18px)',
        fontWeight: 700,
        color: theme.palette.text.primary,
        textAlign: 'center',
        margin: 0,
    },
    appPageTitleTextStart: {
        textAlign: 'start',
    },
    appPageTitleDividerWrap: {
        width: '100%',
        height: 1,
        position: 'relative',
    },
    authTitle: {
        fontSize: 20,
        fontWeight: 700,
        color: theme.palette.text.primary,
        textAlign: 'center',
        margin: 0,
    },
    authSignupLink: {
        fontSize: 13,
        color: '#005496',
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    authSignupLine: {
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        flexWrap: 'wrap',
        justifyContent: 'center',
    },
    authSignupText: {
        fontSize: 13,
        color: 'rgba(0,0,0,0.7)',
    },
    authForgotWrap: {
        textAlign: 'center',
    },
    authTermsRow: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 8,
        flexWrap: 'wrap',
        width: '100%',
        '& .MuiFormControlLabel-root': {
            width: '100%',
            margin: 0,
            alignItems: 'flex-start',
        },
    },
    authTermsLink: {
        fontSize: 13,
        color: '#005496',
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    authFieldLabel: {
        fontSize: 12,
        color: 'rgba(0,0,0,0.6)',
        marginBottom: 4,
        display: 'block',
    },
    pillRoot: {
        backgroundColor: '#f3f6fb',
        borderRadius: 999,
        paddingLeft: 16,
        paddingRight: 16,
        height: 48,
        '&::before, &::after': { display: 'none' },
        '&.Mui-focused': {
            backgroundColor: '#f3f6fb',
            boxShadow: 'none',
        },
    },
    pillInput: {
        backgroundColor: 'transparent !important',
        boxShadow: 'none !important',
    },
    pillAdornment: {
        '&.MuiInputAdornment-root': {
            marginLeft: 0,
            marginRight: 0,
        },
    },
    authInputWrap: {
        width: '100%',
        marginBottom: 14,
        '& .MuiFormControl-root': {
            width: '100%',
        },
        '& .MuiInput-root': {
            backgroundColor: '#f3f6fb',
            borderRadius: 999,
            paddingLeft: 16,
            paddingRight: 16,
            height: 48,
            '&::before, &::after': {
                display: 'none',
            },
            '&.Mui-focused, &:focus-within': {
                backgroundColor: '#f3f6fb',
                boxShadow: 'none',
            },
        },
        '& .MuiInput-input': {
            paddingLeft: 8,
            paddingRight: 8,
            backgroundColor: 'transparent !important',
            boxShadow: 'none !important',
        },
        '& .MuiInputLabel-root': {
            fontSize: 13,
        },
        '& .MuiFormHelperText-root': {
            marginLeft: 16,
            marginRight: 16,
        },
    },
    authInputIcon: {
        width: 18,
        height: 18,
        objectFit: 'contain',
        display: 'block',
    },
    authInputErrorText: {
        width: '100%',
        marginTop: theme.spacing(0.75),
        paddingInlineStart: theme.spacing(0.5),
        color: theme.palette.error.main,
        fontSize: 12,
        textAlign: 'start',
    },
    authSignupInputRoot: {
        '& input::placeholder': {
            color: 'rgba(0, 0, 0, 0.52)',
            opacity: 1,
        },
        '& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus': {
            WebkitBoxShadow: '0 0 0 1000px transparent inset',
            WebkitTextFillColor: theme.palette.text.primary,
            transition: 'background-color 9999s ease-in-out 0s',
            caretColor: theme.palette.text.primary,
        },
    },
    authSignupPasswordToggle: {
        padding: theme.spacing(0.5),
        color: 'rgba(0, 0, 0, 0.45)',
    },
    authActionsContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: theme.spacing(1),
    },
    authActionRow: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(1.5),
    },
    authActionButton: {
        minHeight: 36,
        paddingTop: theme.spacing(0.25),
        paddingBottom: theme.spacing(0.25),
    },
    authSignupInlineText: {
        fontSize: 16,
        lineHeight: 1.2,
        fontWeight: 400,
        color: 'inherit',
        display: 'inline-flex',
        alignItems: 'baseline',
    },
    authSignupInlineBold: {
        fontWeight: 700,
    },
    authPrimaryBtn: {
        width: '100%',
        borderRadius: 999,
        minHeight: 48,
        borderBottom: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        backgroundColor: '#005496 !important',
        color: 'white !important',
        marginTop: 20,
        textDecoration: 'none',
        '& .MuiTypography-root': {
            color: 'white !important',
            fontSize: 15,
            fontWeight: 600,
            lineHeight: 1.2,
        },
        '&:hover': {
            backgroundColor: '#005496 !important',
            color: 'white !important',
        },
        '&:disabled, &.Mui-disabled': {
            backgroundColor: 'rgba(0,84,150,0.6) !important',
            color: 'white !important',
        },
        '&:disabled .MuiTypography-root, &.Mui-disabled .MuiTypography-root': {
            color: 'white !important',
        },
    },
    authSecondaryBtn: {
        width: '100%',
        borderRadius: 999,
        height: 48,
        border: '2px solid #005496',
        color: '#005496',
        backgroundColor: 'transparent !important',
        fontSize: 15,
        marginTop: 10,
        '&:hover': {
            border: '2px solid #005496',
            color: '#005496',
            backgroundColor: 'rgba(0,84,150,0.04) !important',
        },
    },
    authLink: {
        textDecoration: 'none',
        color: '#005496',
        fontSize: 13,
        marginTop: 12,
        display: 'inline-block',
        background: 'none',
        border: 'none',
        padding: 0,
        minWidth: 0,
        textTransform: 'none',
        '&:hover': {
            textDecoration: 'underline',
            background: 'none',
        },
    },
    authFooterVersion: {
        marginTop: 12,
        fontSize: 12,
        color: 'rgba(0,0,0,0.5)',
        textAlign: 'center',
    },
    authLanguageWrap: {
        marginTop: 0,
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        maxWidth: 360,
    },
    btnCont: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },

    placeholderText: {
        '::placeholder': {
            fontSize: '8px', // Adjust the font size as needed
        },
    },
    highlightedButton: {
        // Increase the size
        transform: 'scale(1.1)',
        border: '2px solid #ffffff',
        animation: '$flash-animation 2s infinite',
        borderRadius: 'border-radius: 20px;',
    },
    '@keyframes flash-animation': {
        '0%, 100%': {
            opacity: 2,
            backgroundColor: '#ffffff', // Normal color
        },
        '50%': {
            opacity: 0.5,
            backgroundColor: 'green', // Flash color
        },
    },
    handleWrapper: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignContent: 'center',
        alignItems: 'center',
    },
    // ----------------------------------------
    AccordionComponentRow: {
        display: 'flex',
        justifyContent: 'space-evenly',
        marginBottom: '0.5vh',
    },
    // ----------------------------------------
    mapContainer: {
        marginTop: '5vh',
        maxHeight: '70vh',
        margin: '1vw',
        overflow: 'auto',
    },
    // ----------------------------------------
    pchip: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '20rem',
        height: '1.5rem',
    },
    chipRoot: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        '& > *': {
            margin: theme.spacing(0.5),
        },
        width: (props) => props.width,
    },
    chip: {
        color: (props) => props.color,
        // backgroundColor: (props) => props.backgroundColor,
        width: '100%',
        height: (props) => props.height,
        fontSize: 15,
        // fontWeight: 'bold',
        border: 'none',
    },
    basicTimeBoxRight: {
        maxWidth: '85px',
    },
    basicTimeBoxLeft: {
        marginTop: 'auto',
    },
    connectorBox: {
        marginTop: '2vh',
        marginRight: '5vh',
        marginLeft: '5vh',
        textAlign: 'center',
    },
    startBtn: {
        height: 21,
        fontSize: 10,
    },
    stopBtn: {
        height: 21,
        fontSize: 10,
    },

    buttonText: {
        paddingTop: 8,
    },
    itemStatus: {
        paddingTop: 11,
        textAlign: 'center',
    },
    flexRow: {
        display: 'flex',
        flexDirection: 'row',
    },
    flexColumn: {
        display: 'flex',
        flexDirection: 'column',
    },
    flexAlignCenter: {
        alignItems: 'center',
    },
    flexContentCenter: {
        justifyContent: 'center',
    },
    flexContentEvenly: {
        justifyContent: 'space-evenly',
    },
    flexContentBetween: {
        justifyContent: 'space-between',
    },
    flexContentEnd: {
        justifyContent: 'flex-end',
    },
    flexContentStart: {
        justifyContent: 'flex-start',
    },
    gap5: {
        gap: '5px',
    },
    gap10: {
        gap: '10px',
    },
    gap15: {
        gap: '15px',
    },
    gap20: {
        gap: '20px',
    },
    fullWidth: {
        width: '100%',
    },
    width30: {
        width: '30%',
    },
    width30vw: {
        width: '30vw',
    },
    screenContainer: {
        padding: '0 16px',
    },
    screenContainer2rem: {
        padding: '0 2rem',
    },
    screenContainer05rem: {
        padding: '0 0.5rem',
    },
    marginTop5: {
        marginTop: '5px',
    },
    marginTop10: {
        marginTop: '10px',
    },
    marginTop15: {
        marginTop: '15px',
    },
    marginTop20: {
        marginTop: '20px',
    },
    margin0: {
        margin: '0',
    },
    margin_left_right5_5: {
        margin: '0 5px',
    },
    padding10: {
        padding: '10px',
    },
    font10: {
        fontSize: '10px',
    },
    font15: {
        fontSize: '15px',
    },
    positionFixed: {
        position: 'fixed',
    },

    loader: {
        position: 'fixed',
        inset: '0px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        /*background: 'white',*/
        marginTop: '5vh',
        marginBottom: '56px',
        zIndex: '3000',
    },
    'rotate-star': {
        animation: '$rotate-star-animation 1s ease-in-out',
    },
    '@keyframes rotate-star-animation': {
        '0%': {
            transform: 'rotate(0deg)',
        },
        '100%': {
            transform: 'rotate(360deg)',
        },
    },
    muiAccordionNoPadding: {
        padding: 0,
    },
    suspendTitle: {
        display: 'flex',
        justifyContent: 'center',
        fontSize: 16,
        fontWeight: 'bold',
        color: 'red',
    },
}));

export default useStyles;
